import styled, { keyframes } from 'styled-components';
import { media } from '@/styles/Qtheme.ts';

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const floatAnimation = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
`;

export const AssetOverallSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  animation: ${fadeInUp} 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
`;

export const AssetOverallContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 34px;
  position: relative;

  > * {
    animation: ${fadeInUp} 0.6s cubic-bezier(0.4, 0, 0.2, 1) forwards;

    &:nth-child(1) {
      animation-delay: 0.1s;
    }
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.3s;
    }
  }

  @media ${media.mobile} {
    gap: 24px;
  }
`;

export const AssetOverallHeaderSection = styled.div`
  width: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  background: rgba(0, 110, 73, 0.08);
  border-radius: 30px;
  border: none;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  .ant-select {
    .ant-select-selector {
      background: rgba(91, 93, 107, 0.3) !important;
      border: none !important;
      border-radius: 8px !important;
      height: 36px !important;

      .ant-select-selection-item {
        font-family: 'NanumSquareRound', sans-serif;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: -0.32px;
        line-height: 36px;
      }

      .ant-select-selection-placeholder {
        font-family: 'NanumSquareRound', sans-serif;
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: -0.32px;
        line-height: 36px;
      }
    }

    &.ant-select-focused .ant-select-selector {
      box-shadow: none !important;
    }
  }

  .ant-picker {
    background: rgba(91, 93, 107, 0.3) !important;
    border: none !important;
    border-radius: 8px !important;
    height: 36px !important;

    .ant-picker-input > input {
      font-family: 'NanumSquareRound', sans-serif;
      font-size: 16px;
      font-weight: 700;
      color: #ffffff;
      letter-spacing: -0.32px;
    }

    &.ant-picker-focused {
      box-shadow: none !important;
    }
  }

  @media ${media.mobile} {
    padding: 28px 24px;
    border-radius: 30px;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  margin-top: 20px;
  z-index: 1;
  position: relative;

  @media ${media.mobile} {
    gap: 12px;
  }
`;

export const FilterItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 140px;

  @media ${media.mobile} {
    min-width: 100%;
  }
`;

export const FilterLabel = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #b3b5bd;
  letter-spacing: -0.24px;
`;

export const HeaderTitle = styled.h2`
  font-family: 'Aggro', 'Aggro', sans-serif;
  font-size: 28px;
  font-weight: 500;
  color: #ffffff;
  letter-spacing: -0.56px;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  z-index: 1;
  position: relative;

  @media ${media.mobile} {
    font-size: 24px;
  }
`;

export const HeaderDescription = styled.p`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #b3b5bd;
  letter-spacing: -0.32px;
  margin: 8px 0 0 0;
  z-index: 1;
  position: relative;

  @media ${media.mobile} {
    font-size: 14px;
  }
`;
